import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userConferencesStateSelector} from './user-conferences-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {LicenseSearchInfo} from 'src/openapi/admin/models/LicenseSearchInfo';

export const userConferencesLicenseSlice = getCachedTableDataSlice<
    Record<string, LicenseSearchInfo>,
    AccountSearchCriteria,
    AccountSortField,
    undefined
>('userConferencesLicense');

export const userConferencesLicenseActions = userConferencesLicenseSlice.actions;

const userConferencesLicenseCacheSelector: CachedTableCacheSelector<Record<string, LicenseSearchInfo>>
    = state => state.userPage.tabs.userConferences.license.cache;
export const userConferencesLicenseDataSelector: CachedTableDataSelector<Record<string, LicenseSearchInfo>>
    = state => state.userPage.tabs.userConferences.license;
export const userConferencesLicenseResultSelector = getCachedTableResultSelector(
    userConferencesLicenseCacheSelector,
    userConferencesStateSelector,
);
